import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://euyiftrkcmjcwdijmxlj.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV1eWlmdHJrY21qY3dkaWpteGxqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY4MTAzODAsImV4cCI6MjA3MjM4NjM4MH0.RZBNYOKNfwI2Q2ChCmg8Hn2kdqEEkCjlAQVSHO13LrI'

if(SUPABASE_URL == 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY == '<ANON_KEY>' ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})